module.exports = __webpack_public_path__ + "static/media/Knight439_3C.14687a72.svg";